module.exports = __webpack_public_path__ + "static/media/Program16.3905f511.jpg";